<div class="coming-soon-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="coming-soon-content">
                <a routerLink="/" class="logo">
                    <img src="assets/img/logo-cace-sf.png" alt="image">
                </a>
                <h2>Nous lançons</h2>
                <div id="timer" class="flex-wrap d-flex justify-content-center">
                    <div id="" class="align-items-center flex-column d-flex justify-content-center">Bientôt</div>
                </div>
                <form class="newsletter-form">
                    <p>La page que vous demandez est en cours de conception, elle sera bientôt disponible. Merci.</p>
                </form>
            </div>
        </div>
    </div>
</div>